import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from 'react-icons/fa';
import { BsArrowRightShort } from 'react-icons/bs';
import TitleSection from 'components/common/TitleSection';

const ContactForm = () => {
  const leftSideHead = {
    upperTitle: '',
    middleTitle: 'want to talk ?',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  const rightSideHead = {
    upperTitle: '',
    middleTitle: "Let's Hear It From You",
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  return (
    <section className='contactFormSec DBlock py-10 sm:py-12 px-6 sm:px-10'>
      <div className='max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8'>
        <div>
          <TitleSection titleDetail={leftSideHead} />
          <form onSubmit={(e) => e.preventDefault()} className='DBlock'>
            <input
              type='text'
              name='name'
              id='name'
              required
              placeholder='Name'
              autoComplete='name'
              className='mb-5 sm:my-5 block w-full rounded-full border-gray-300 bg-transparent shadow-sm focus:border-eventLightYellow focus:ring-eventborder-eventLightYellow hover:border-eventLightYellow hover:ring-eventborder-eventLightYellow border text-xs lg:text-sm p-3 '
            />
            <input
              type='email'
              name='email'
              id='email'
              required
              placeholder='Email'
              autoComplete='email'
              className='my-5 block w-full rounded-full border-gray-300 bg-transparent shadow-sm focus:border-eventLightYellow focus:ring-eventborder-eventLightYellow hover:border-eventLightYellow hover:ring-eventborder-eventLightYellow border text-xs lg:text-sm p-3 '
            />
            <textarea
              type='text'
              name='message'
              id='message'
              placeholder='Message'
              autoComplete='message'
              rows={5}
              className='mt-5 mb-8 block w-full rounded-lg border-gray-300 bg-transparent shadow-sm focus:border-eventLightYellow focus:ring-eventborder-eventLightYellow hover:border-eventLightYellow hover:ring-eventborder-eventLightYellow border text-xs lg:text-sm p-3 '
            />
            <button
              className='flex items-center justify-between text-white text-sm sm:text-base rounded-full py-3 px-4 bg-eventLightYellow'
              type='submit'>
              Create Reservation <BsArrowRightShort size={22} />
            </button>
          </form>
        </div>
        <div>
          <TitleSection titleDetail={rightSideHead} />
          <div className='DBlock'>
            <p className='text-eventGray sm:text-base text-sm font-light'>
              With over 18 years of experience we are known to create out of the
              box brand stories across various platforms to produce effective
              and enduring results in today’s rapidly evolving marketplace. We
              like re-imagining the future for our clients and to break new
              grounds and revolutionize the brand stories through the campaigns
              that we create.
            </p>
            <div className='pt-6'>
              <h2 className='font-bold text-sm uppercase pb-4'>contact:</h2>
              <div className='grid grid-cols-1 lg:grid-cols-2 gap-4'>
                <div>
                  <p className='text-eventGray font-normal text-sm'>
                    <span className='font-bold text-sm text-black pr-1 sm:inline-block block'>
                      Address:
                    </span>
                    Address: 1st Floor, 50 Garden Height, Garden Town Lahore
                  </p>
                  <p className='text-eventGray font-normal text-sm py-3'>
                    <span className='font-bold text-sm text-black pr-1 sm:inline-block block'>
                      Email:
                    </span>
                    info@js.com.pk
                  </p>
                </div>
                <div>
                  <p className='text-eventGray font-normal text-sm'>
                    <span className='font-bold text-sm text-black pr-1 sm:inline-block block'>
                      Phone:
                    </span>{' '}
                    04232560856, 04232560857, <br />
                    0300 4368333
                  </p>
                  <h2 className='dashBorder font-bold text-sm uppercase py-4'>
                    follow us on:
                  </h2>
                  <ul className='flex items-center gap-4 text-eventLightYellow'>
                    <li className='text-lg sm:text-xl'>
                      <a href='#'>
                        <FaFacebookF />
                      </a>
                    </li>
                    <li className='text-lg sm:text-xl'>
                      <a href='#'>
                        <FaTwitter />
                      </a>
                    </li>
                    <li className='text-lg sm:text-xl'>
                      <a href='#'>
                        <FaLinkedinIn />
                      </a>
                    </li>
                    <li className='text-lg sm:text-xl'>
                      <a href='#'>
                        <FaInstagram />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
